import { render, staticRenderFns } from "./TestEdit.vue?vue&type=template&id=4182818d&"
import script from "./TestEdit.vue?vue&type=script&lang=ts&"
export * from "./TestEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports